module.exports = __webpack_public_path__ + "static/media/img_rimbun_banner_1.89e08c38.jpg";